<div class="price-detail">
  <ng-container *ngIf="rendition !== defaultRendition ">
    <div class="before" [translate]="'eos-tv-shop-ii.lbl.price-starting-from'"></div>
    <app-spacer spacerSize="10"></app-spacer>
  </ng-container>

  <div *ngIf="hasPromo" class="price--original-price">
    <span *ngIf="getCurrentLang !== 'fr'" class="currency">€</span>
    <span>{{textIntegerPart}}{{textDecimalPart}}</span>
    <span *ngIf="getCurrentLang === 'fr'" class="price-left currency">€</span>
  </div>

  <div class="price" [ngClass]="{'play-price-font':isPlay}">
    <span class="price-left">
      <span *ngIf="getCurrentLang !== 'fr'" class="currency">€</span>
      <span>{{promoTextIntegerPrice}}</span>
    </span>
    <span class="price-right comma">{{promoTextDecimalPart}}</span>
    <span *ngIf="getCurrentLang === 'fr'" class="price-left">
      <span class="currency-left">€</span>
    </span>
  </div>

  <div class="after" [ngClass]="{'play-price-font':isPlay}">
    /<span [translate]="'eos-tv-shop-ii.lbl.price-month'"></span>
  </div>

  <div *ngIf="promoLabel"
       class="price--promo-label"
       [translate]="'eos-tv-shop-ii.lbl.' + promoLabel"
       [translateParams]="{ duration: promoDuration }">
    gedurende x maand(en)
  </div>
</div>

<app-badge *ngIf="promoTextKey" [badgeCopy]="'eos-tv-shop-ii.lbl.' + promoTextKey" position="bc"></app-badge>
